import { object, string } from 'yup';
import dynamoDB from '@/aws/aws-dynamoDB';

const validationSchema = object({
  id: string().min(3).notOneOf(['ALL'], "ID must not be 'ALL'").required(),
  name: string().min(3).required(),
  topic: string().required(),
});

export default async function (input, successCallback = e => e, errorCallback = e => e) {
  try {
    // validate input (throws an error if input is invalid)
    await validationSchema.validate(input);

    // delete file from database
    const result = await dynamoDB.createDBTag(input);

    // eslint-disable-next-line no-constant-condition
    if (result.$metadata.httpStatusCode >= 200 && result.$metadata.httpStatusCode < 300) {
      successCallback(input);
    } else {
      errorCallback(result);
    }
  } catch (error) {
    if (error.name === 'ConditionalCheckFailedException') {
      errorCallback(new Error(`Item with id [ ${input.id} ] already exists`));
      return;
    }
    errorCallback(error);
  }
}
